import type z from 'zod'

import { schemas } from '~interface/zod-schema'

export const PricingTierEnum = schemas.PricingTierEnum
export type PricingTier = z.infer<typeof PricingTierEnum>

export const AccessTierEnum = schemas.AccessTierEnum
export type AccessTier = z.infer<typeof AccessTierEnum>

export type OrgIdentityTier = z.infer<typeof schemas.OrgIdentityTier>
